module.exports = __webpack_public_path__ + "img/9.d7629279.png";